/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ActorAttribute,
  ActorAttribute$inboundSchema,
} from "./actorattribute.js";

export type ListActorAttributesResult = {
  /**
   * The member attributes available to target conditions, in editor display order.
   */
  attributes: Array<ActorAttribute>;
};

/** @internal */
export const ListActorAttributesResult$inboundSchema: z.ZodMiniType<
  ListActorAttributesResult,
  unknown
> = z.object({
  attributes: z.array(ActorAttribute$inboundSchema),
});

export function listActorAttributesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListActorAttributesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListActorAttributesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListActorAttributesResult' from JSON`,
  );
}
